import { render } from "./card-contacts.vue?vue&type=template&id=d9f93036&scoped=true&ts=true"
import script from "./card-contacts.vue?vue&type=script&lang=ts"
export * from "./card-contacts.vue?vue&type=script&lang=ts"

import "./card-contacts.vue?vue&type=style&index=0&id=d9f93036&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f93036"]])

export default __exports__